/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useContext, useState } from "react";
import { ThemeContext } from "../../App";

import { Box, AppBar, Toolbar, CssBaseline, Typography, IconButton, Tooltip } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import { Brightness3, Brightness7 } from "@mui/icons-material";

import { useWindowDimensions } from "../../utils/Hooks";

export interface NavProps {
    children: JSX.Element | JSX.Element[];
}

const StandaloneNav = (props: NavProps) => {
    const { children } = props;

    const isDarkTheme = localStorage.getItem("techwiseTheme") === "dark";

    const { width } = useWindowDimensions();
    const isMobile = width <= 1200;
    const [mobileOpen, setMobileOpen] = useState(false);

    const { setTheme } = useContext(ThemeContext);

    const toggleDarkTheme = () => {
        const theme = isDarkTheme ? "light" : "dark";
        setTheme(theme);
        localStorage.setItem("techwiseTheme", theme);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                // @ts-ignore
                sx={{
                    background: isDarkTheme
                        ? process.env.REACT_APP_BACKGROUND_COLOR_DARK
                        : process.env.REACT_APP_PRIMARY_COLOR_LIGHT,
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: "none" } }}
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                        {isMobile ? process.env.REACT_APP_TITLE_MOBILE : process.env.REACT_APP_TITLE_DESKTOP}
                    </Typography>

                    <Box>
                        {isDarkTheme && (
                            <Tooltip title="Enable Light Theme">
                                <IconButton onClick={() => toggleDarkTheme()}>
                                    <Brightness7 />
                                </IconButton>
                            </Tooltip>
                        )}

                        {!isDarkTheme && (
                            <Tooltip title="Enable Dark Theme">
                                <IconButton onClick={() => toggleDarkTheme()}>
                                    <Brightness3 sx={{ color: "white" }} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
                <Toolbar />
                {children}
            </Box>
        </Box>
    );
};

export default StandaloneNav;
